import { DEFAULT_TINT_PRICE_PER_UNIT } from '../consts/tint-price.consts';

type TParams = {
  volume?: string | null;
  count: string;
};
export const getTintPrice = ({ volume, count }: TParams) => {
  if (volume === undefined || volume === null) {
    return null;
  }

  if (Number.isNaN(volume) || Number.isNaN(count)) {
    return null;
  }

  return Number(volume) * Number(count) * DEFAULT_TINT_PRICE_PER_UNIT;
};
